import type { GroupRestaurant } from '../api/restaurantGroups';
import { getCurrentDomainConfig } from '@core/tenant/getSubdomainPrefix';

/**
 * Booking home for a restaurant: {subdomainPrefix}.{baseDomain}
 * The base domain is derived from the current environment so that staging
 * (go.meitre-test.com) produces staging reserve links instead of prod links.
 */
export function groupReserveUrl(restaurant: GroupRestaurant): string {
  const base = getCurrentDomainConfig()?.baseDomain ?? 'meitre.com';
  return `https://${restaurant.subdomainPrefix}.${base}`;
}
